export default __webpack_public_path__ + "static/media/bar-fuel-cards.a6b25a35.svg";